<template>
    <div class="row main-content" id="imageGallery">
        <div class="col-md-2">
            <sidebar>Image Gallery</sidebar>
        </div>
        <div class="col-md-10">
            <div style="width:100%;">
                <h3>ENTER ITEM #</h3>
                <div class="row" style="padding-left:15px;white-space:nowrap">
                    <form @submit.prevent="searchItem">
                        <autocomplete
                            :source="items"
                            placeholder="Enter Item #..."
                            @selected="selectItem"
                            style="display:inline-block;">
                        </autocomplete>
                        <button class="btn-round-red" type="submit" style="display:inline-block;">SEARCH ITEM ></button>
                    </form>
                </div>
            </div>
            <br>
            <div>
                <h4>OR</h4>
                <br>
                <h3>
                    PRODUCT IMAGE BULK DOWNLOAD<br>
                    <small>Total file size: {{ bulkDownloadSize }}</small>
                </h3>
                <p>
                    To download all PIP® products click on the <strong>DOWNLOAD ALL</strong> button. This will create a zip file that will consist of a folder of product images and a workbook that lists the SKU number and associated product iamge name. If there are multiple images per SKU, please use the <strong>Sort Column</strong> to find the image priority (1 being the primary image).
                </p>
                <a :href="zipFileURL" class="btn-round-red" download="Retail-Product-Images-SKU-Level.zip" style="font-size:.7rem">DOWNLOAD ALL</a>
            </div>
        </div>
    </div>
</template>

<script>
import Autocomplete from "vuejs-auto-complete";
export default {
    components: {
        Autocomplete
    },
    data() {
        return {
            bulkDownloadSize: "",
            items: [],
            selectedItem: "",
            zipFileURL: "/archive/zip/Retail-Product-Images-SKU-Level.zip"
        }
    },
    created() {
        axios.get(`/api/getItemsForImageGalleryAutocomplete`).then(response => {
            this.items = response.data;
        });
        axios.get(`/api/getBulkImageDownloadSize`).then(response => {
            this.bulkDownloadSize = response.data;
        });
    },
    methods: {
        searchItem() {
            this.$router.push({
                name: "ImageGalleryResults",
                params: { prodId: this.selectedItem }
            
            });
        },
        selectItem(result) {
            this.selectedItem = result.value;
        },
    },
}
</script>
